
// FormaPagamentoSelect.js

import React from 'react';

const FormaPagamentoSelect = ({ paymentMethods, selectedMethod, onChange }) => {
  return (
    <div style={{ width: '200px', marginLeft: '20px', marginTop: '0px', marginBottom: '0px' }}>
      <label htmlFor="payment-method" style={{ display: 'block', marginBottom: '0px' }}>
        Forma de Pagamento:
      </label>
      <select 
        id="payment-method" 
        value={selectedMethod} 
        onChange={(e) => onChange(e.target.value)} 
        style={{ width: '200px', height: '30px' }}
      >
        <option value="" disabled>Selecione uma forma de pagamento</option>
        {paymentMethods.map((method, index) => (
          <option key={index} value={method}>
            {method}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FormaPagamentoSelect;